import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IFrameworkResource, IFrameworkTranslationList } from "../types";

export interface IFrameworkTranslationsQueryParameters {
    framework?: RelationalValue<IFrameworkResource>;
}

export type IFrameworkTranslationsQueryResult = IFrameworkTranslationList;

export const frameworkTranslationsQuery: IApiQueryFunction<IFrameworkTranslationsQueryParameters> = ({ framework }) => {
    if (!framework) {
        return;
    }

    return {
        method: "GET",
        url: `/frameworks/${mapRelationalValue(framework)}/translations`,
    };
};

export const useFrameworkTranslationsQuery = createApiQueryHook<
    IFrameworkTranslationsQueryParameters,
    IFrameworkTranslationsQueryResult
>(frameworkTranslationsQuery);
